import Image1 from "../../assets/woman1.png";
import Image2 from "../../assets/man.png";
import Image3 from "../../assets/woman2.png";

export const Data = [
    {
        id: 1,
        image: Image1,
        title: "Kris C.",
        description: "Executed the concept with clarity and adaptability.",
    },
    {
        id: 2,
        image: Image2,
        title: "Mark S.",
        description: "Provided creative insight and improvment to the project.",
    },
    {
        id: 3,
        image: Image3,
        title: "Gemma B.",
        description: "Fixed the glitch and made the site easier to use.",
    },
];